var _rect, _rect2, _rect3, _rect4, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFirstArrows(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1215,
    height: 646,
    viewBox: "0 0 1215 646",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -1.75,
    y: -1.75,
    width: 3.5,
    height: 4.5,
    transform: "matrix(0 -1 -1 0 37.5007 395.5)",
    stroke: "#D7544F",
    strokeWidth: 3.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 449.75,
    y: 644.25,
    width: 3.5,
    height: 4.5,
    transform: "rotate(-90 449.75 644.25)",
    stroke: "#4E5055",
    strokeWidth: 3.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 449.751,
    y: 522.25,
    width: 3.5,
    height: 4.5,
    transform: "rotate(-90 449.751 522.25)",
    stroke: "#D7544F",
    strokeWidth: 3.5
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 449.751,
    y: 602.25,
    width: 3.5,
    height: 4.5,
    transform: "rotate(-90 449.751 602.25)",
    stroke: "#D7544F",
    strokeWidth: 3.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M73.0007 396H38.0007",
    stroke: "#D7544F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M46.0007 601H41.0007",
    stroke: "#D7544F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M324 521L448 521",
    stroke: "#4E5055"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M372.001 643L448.001 643",
    stroke: "#4E5055"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M35 396L30.9997 396C14.4313 396 1.00002 382.568 1.00002 366V31C1.00002 14.4314 14.4315 1 31 1H41.8225",
    stroke: "#D7544F"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M454 643L474.001 643C490.569 643 504 629.568 504 613V31C504 14.4314 517.432 1 534 1H625.5",
    stroke: "#4E5055"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M454 521L458.001 521C474.569 521 488.001 507.568 488.001 491V234C488.001 217.431 501.432 204 518.001 204H1142C1158.57 204 1172 190.569 1172 174V31.5C1172 14.9315 1185.43 1.5 1202 1.5H1215",
    stroke: "#D7544F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M454 601L458.001 601C474.569 601 488 587.568 488 571V458",
    stroke: "#D7544F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstArrows);
export default __webpack_public_path__ + "static/media/first-arrows.1978c131f49182862ea422fc16d18042.svg";
export { ForwardRef as ReactComponent };